<template>
    <div class="payment__form">
        <form
            v-if="
                state.currentView == 'MOMO_MALAWI_INIT_VIEW' &&
                    state.processing != true
            "
            @submit.prevent="checkPhone"
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("mm.init.instruction")}}
            </h5>
            <primary-input
                :title="$t('mm.input.phone')"
                type="tel"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                placeholder="07013926478"
                @value-change="telephone = $event"
                :defaultValue="getValueFromPath(state, 'inputs.phone.value') || null"
                :isRequired="getValueFromPath(state, 'inputs.phone.required') || true"
                inputName="phone"
                :number-only="true"
            />
            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                type="submit"
            />
        </form>
        <div
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <div class="redirect-wrapper">
                <img
                    class="redirect-icon"
                    :src="require('@/assets/icons/redirect.svg')"
                    alt="redirect-icon"
                />
            </div>
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{$t("mm.redirect.instruction")}}
            </p>
            <PrimaryButton :content="$t('ui.redirect.btn')" @click="Next" />
        </div>
        <div
            v-else-if="
                checkoutData.view.current == 'MOMO_MALAWI_CONFIRM_VIEW' &&
                    checkoutData.processing != true
            "
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("mm.notification.message")}}
            </h5>
            <div class="loader-container">
                <div class="loader-wrapper">
                    <div class="loader-icon"></div>
                </div>
            </div>
            <p class="payment__instruction--refresh">{{$t("ui.transaction.refresh")}}.</p>
        </div>
    </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { injectStore, mapState } from "redux-vuex";
import { ref, onBeforeUnmount, watch } from "vue";

import { getValueFromPath } from "@/support/helpers";
import { isValidPhoneNumber } from "../../support/helpers";
import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";

export default {
    name: "MobileMoneyMalawi",
    components: {
        PrimaryInput,
        PrimaryButton,
    },
    setup(_, { emit }) {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const telephone = ref("");
        const transactionSuccessful = ref(false);
        const momoError = ref(false);
        const errorMessage = ref("");
        const { t } = useI18n();

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function checkPhone() {
            if (telephone.value != "") {
                let trimmedPhoneNumber = telephone.value.replace(/\s/g, "").replace(/[()]/g, "");

                if (isValidPhoneNumber(trimmedPhoneNumber)) {
                    momoError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = "";
                    telephone.value = trimmedPhoneNumber;
                    step2();
                } 
                else {
                    momoError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = t("mm.invalid.phonenumber");
                }
            }
        }

        function step2() {
            const data = { phone: telephone.value };
            checkoutData.value.view.context.$actions.update(data);
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }

        watch(momoError, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                emit("momo-error", errorMessage.value);
            }
        });

        watch(() => checkoutData.value, (newData) => {
            if (newData) {
                momoError.value = false;
            }
        });

        onBeforeUnmount(() => {
            momoError.value = false;
            errorMessage.value = "";
            subscription();
        });

        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                defaultNetwork: (state) =>
                    getValueFromPath(state, "view.context.inputs.network.value"),
                networks: (state) =>
                    getValueFromPath(state, "view.context.inputs.network.options") || [],
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            checkoutData,
            getValueFromPath,
            telephone,
            transactionSuccessful,
            checkPhone,
            step2,
            Next,
        };
    },
};
</script>

<style scoped>
</style>